import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './TextCell.css';

export interface TextProps {
    capitalize?: boolean;
    cls?: string;
}

export const TextCell: React.FC<TextProps> = React.memo(({ children = '–', capitalize, cls }) => (
    <div
        className={classNames(
            cls,
            Bem.cls({
                block: 'text-cell',
                mods: {
                    capitalized: Boolean(capitalize)
                }
            })
        )}
    >
        {children}
    </div>
));
